import React, { useEffect, useState } from "react";
import { FormLabel } from "react-bootstrap";
import {
  Backdrop,
  CircularProgress,
  Divider,
  Switch,
  TextField,
  withStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import Button from "react-bootstrap/Button";
import { Loader } from "../custom/CommonFunction";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import CommonIcon from "../helpers/icons";
import {
  getParticularUser,
  updateUser,
  changePassword,
} from "../../action/UsersApi";
import Setpassword from "./Setpassword";
import { ToastContainer, toast } from "react-toastify";
import { Password } from "@mui/icons-material";
import toggleMenu from "../../redux/SideBar/sideBarActions";
import { Autocomplete, InputAdornment } from "@mui/material";
import $ from "jquery";
import API from "../helpers/endpointservice";
import Actions from "../../action/api";
import Countries from "../helpers/countries";
// import parsePhoneNumber, { parsePhoneNumberFromString } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from "libphonenumber-js/max";

const ProfileUI = (props) => {
  const dispatch = useDispatch();
  const [tooglepassword, setTooglepassword] = useState(false);
  const [basicDetails, setBasicDetails] = useState(true);
  const [opendialog, setOpendialog] = useState(false);
  const [resetDialog, setResetDialog] = useState(false);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneCode, setPhonceCode] = useState("");
  const [details, setDetails] = useState();
  const [isSSO, setIsSSO] = useState();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [conformPassword, setConformPassword] = useState("");
  const [toggleConformPassword, setToggleConformPassword] = useState(true);
  const [togglenewpassword, setTogglenewpassword] = useState(true);
  const [toggleCurrentpassword, setToggleCurrentpassword] = useState(true);
  const [newpasswordError, setNewPasswordError] = useState("");
  const [currentpasswordError, setCurrentPasswordError] = useState("");
  const [conformpasswordError, setConformPasswordError] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [tempUser, setTempUser] = useState(null);
  const [isWebMobile, setIsWebMobile] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const [countryData, setCountryData] = useState([]);

  const getCountries = () => {
    Actions.GET(API.GET_COUNTRIES)
      .then((res) => {
        if (res.data) {
          const filteredData = res.data
            .filter(
              (item) => item.countryCode && item.countryCode.trim() !== ""
            )
            .map((item) => ({
              ...item,
              // optionally do more transformation here
            }));
          setCountryData(filteredData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const resize = () => {
    // if (window.innerWidth < 850) {
    //     this.setState({
    //         isMobile: true,
    //     })
    // } else {
    //     this.setState({
    //         isMobile: false,
    //         isWebMobile: false
    //     })
    // }

    if (window.innerWidth < 468) {
      setIsWebMobile(true);
      // this.setState({
      //     isMobile600: true,
      //     isWebMobile: true
      // })
    } else {
      setIsWebMobile(false);
      // this.setState({
      //     isMobile600: false,
      //     isWebMobile: false
      // })
    }

    if (window.innerWidth < 380) {
      // this.setState({
      //     isMobile380: true
      // })
      // this.setState({
      //     isMobile380: true
      // })
    } else {
      // this.setState({
      //     isMobile380: false
      // })
    }
    // this.setState({
    //     height: window.innerHeight
    // })
  };

  const handlepasswordchange = () => {
    setTooglepassword(true);
    setBasicDetails(false);
  };

  const handleBasicDetailsmobile = () => {
    setFirstName(tempUser?.firstName);
    setEmail(tempUser?.email);
    setLastName(tempUser?.lastName);
    const fullPhone = tempUser?.phoneNumber || "";
    let primaryPhoneCod = "";
    let primaryPhone = "";
    if (fullPhone.includes("-")) {
      [primaryPhoneCod, primaryPhone] = fullPhone.split("-");
    } else if (fullPhone.startsWith("+")) {
      primaryPhoneCod = fullPhone;
    } else {
      primaryPhone = fullPhone;
    }
    setPhone(primaryPhone);
    setPhonceCode(primaryPhoneCod);
    setPhoneError("");
    setBasicDetails(true);
    setNewPasswordError("");
    setCurrentPasswordError("");
    setConformPasswordError("");
    setCurrentPassword("");
    setConformPassword("");
    setNewPassword("");
    setTooglepassword(false);
    newformdetailsshow();
  };

  const handlepasswordchangemobile = () => {
    setTooglepassword(true);
    setNewPasswordError("");
    setCurrentPasswordError("");
    setConformPasswordError("");
    setBasicDetails(false);
    newformpasswordshow();
  };

  const newformdetailsshow = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("AddForm")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
  };
  const closeForm = () => {
    $("#AddForm").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");

    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
  };
  const newformpasswordshow = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("resetpassword")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
  };
  const closePasswordForm = () => {
    $("#resetpassword").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");

    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
  };

  const handleBasicDetails = () => {
    setFirstName(tempUser?.firstName);
    setEmail(tempUser?.email);
    setLastName(tempUser?.lastName);
    const fullPhone = tempUser?.phoneNumber || "";
    let primaryPhoneCod = "";
    let primaryPhone = "";
    if (fullPhone.includes("-")) {
      [primaryPhoneCod, primaryPhone] = fullPhone.split("-");
    } else if (fullPhone.startsWith("+")) {
      primaryPhoneCod = fullPhone;
    } else {
      primaryPhone = fullPhone;
    }
    setPhone(primaryPhone);
    setPhonceCode(primaryPhoneCod);
    setPhoneError("");
    setBasicDetails(true);
    setNewPasswordError("");
    setCurrentPasswordError("");
    setConformPasswordError("");
    setConformPasswordError("");
    setCurrentPassword("");
    setConformPassword("");
    setTooglepassword(false);
  };
  const countryCodes = ["+1", "+44", "+91", "+33"];

  useEffect(() => {
    setCountryData(Countries);
    // getCountries();
    console.log(JSON.parse(localStorage.getItem("UserInfoTAC")).userId);
    let userid = JSON.parse(localStorage.getItem("UserInfoTAC")).userId;
    props.dispatch(getParticularUser(userid));

    console.log(props.getParticularUser);
    if (props.getParticularUser) {
      setTempUser(props.getParticularUser);
      setFirstName(props.getParticularUser?.firstName);
      setEmail(props.getParticularUser?.email);
      setLastName(props.getParticularUser?.lastName);
      const fullPhone = props.getParticularUser?.phoneNumber || "";
      let primaryPhoneCod = "";
      let primaryPhone = "";
      if (fullPhone.includes("-")) {
        [primaryPhoneCod, primaryPhone] = fullPhone.split("-");
      } else if (fullPhone.startsWith("+")) {
        primaryPhoneCod = fullPhone;
      } else {
        primaryPhone = fullPhone;
      }
      setPhone(primaryPhone);
      setPhonceCode(primaryPhoneCod);
      setIsSSO(props.getParticularUser?.isSSO);
      setDetails(props.getParticularUser);
      props.dispatch({ type: "USER_GET_SUCCESSFULL", data: undefined });
    }
    const intervals = setInterval(() => {
      resize();
    }, 10);
    // showToastupdateMessage()
  }, []);
  useEffect(() => {
    console.log(props.getParticularUser);
    if (props.getParticularUser) {
      setTempUser(props.getParticularUser);
      setFirstName(props.getParticularUser?.firstName);
      setEmail(props.getParticularUser?.email);
      setLastName(props.getParticularUser?.lastName);
      const fullPhone = props.getParticularUser?.phoneNumber || "";
      let primaryPhoneCod = "";
      let primaryPhone = "";
      if (fullPhone.includes("-")) {
        [primaryPhoneCod, primaryPhone] = fullPhone.split("-");
      } else if (fullPhone.startsWith("+")) {
        primaryPhoneCod = fullPhone;
      } else {
        primaryPhone = fullPhone;
      }
      setPhone(primaryPhone);
      setPhonceCode(primaryPhoneCod);
      setIsSSO(props.getParticularUser?.isSSO);
      setDetails(props.getParticularUser);
      // props.dispatch({ type: "USER_GET_SUCCESSFULL", data: undefined })
    }
    if (props.updateUser) {
      // showToastupdateMessage();
      props.dispatch({ type: "USER_UPDATE_SUCCESS", data: false });
    }
    if (props.changePassword?.status == "success") {
      props.dispatch({ type: "PASSWORD_CHANGED", data: undefined });
      showToastChangePasswordMessage();
      setConformPassword("");
      setNewPassword("");
      setCurrentPassword("");
    }
    if (props.changePassword?.status == "fail") {
      showToastErrorchangePassword(props.changePassword?.message);
      props.dispatch({ type: "PASSWORD_CHANGED", data: undefined });
    }
  }, [props.getParticularUser, props.changePassword]);

  const customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 2000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };
  const noAction = () => {
    setOpendialog(false);
  };

  const yesAction = () => {
    dispatch({ type: "IS_LOGIN", data: false });
    setOpendialog(false);
    props.handleLogout();
  };
  const showToastupdateMessage = () => {
    customToast("Updated Successfully !");
  };
  const showToastChangePasswordMessage = () => {
    customToast("Password Changed Successfully !");
  };
  const showToastErrorchangePassword = (value) => {
    customToast(value);
  };

  const handlePhoneValidate = () => {
    let error = false;
    if ((phoneCode !== "" && phoneCode !== null) || phone !== "") {
      if (
        ((phoneCode !== "" || phoneCode !== null) && phone == "") ||
        ((phoneCode == "" || phoneCode == null) && phone !== "")
      ) {
        if (phoneCode !== "" && phoneCode !== null && phone == "") {
          error = true;
          setPhoneError("Phone Number is missing");
        } else if ((phoneCode == "" || phoneCode == null) && phone !== "") {
          error = true;
          setPhoneError("Country Code is missing");
        }
      } else {
        setPhoneError("");
      }

      if (phoneCode !== "" && phoneCode !== null && phone !== "") {
        let bool = validatePhoneNumberByDialCode(phoneCode, phone);
        if (!bool) {
          error = true;
          setPhoneError("Invalid Phone Number");
          // this.state.errorPhoneNo = true;
          // if (!focusErrorField) {
          //     focusErrorField = this.phNoRef.current;
          // }
        } else {
          setPhoneError("");
        }
      }
    } else {
      setPhoneError("");
    }

    return error;
  };

  const handleUpdate = () => {
    if (!handlePhoneValidate()) {
      console.log(details.id);
      let userid = details.id;
      let phonenumber = phone ? phoneCode + "-" + phone : "";
      let data = {
        userId: userid,
        firstName: firstName,
        lastName: lastName,
        email: email,
        isActive: true,
        userRole: "User",
        phonenumber: phonenumber,
      };
      props.dispatch(updateUser(data, userid)).then((res) => {
        let value = JSON.parse(localStorage.getItem("UserInfoTAC"));
        value.name = firstName + " " + lastName;
        console.log(value);
        localStorage.setItem("UserInfoTAC", JSON.stringify(value));
        console.log(JSON.parse(localStorage.getItem("UserInfoTAC")).userId);
        let userid = JSON.parse(localStorage.getItem("UserInfoTAC")).userId;
        props.dispatch(getParticularUser(userid));
        showToastupdateMessage();
      });
    }
  };
  const handleChangePasswordSubmit = () => {
    let isvalid = true;
    if (newPassword.trim() == "") {
      setNewPasswordError("Password is missing.");
      isvalid = false;
    } else {
      const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      if (regex.test(newPassword)) {
        setNewPasswordError("");
      } else {
        setNewPasswordError("Including (A-Z,a-z,0-9 and (!@#$%^&*))");
        isvalid = false;
      }
    }
    if (currentPassword.trim() == "") {
      setCurrentPasswordError("Password is missing.");
      isvalid = false;
    } else {
      setCurrentPasswordError("");
    }

    if (conformPassword.trim() == "") {
      setConformPasswordError("Password is missing.");
      isvalid = false;
    } else {
      if (newPassword.trim() === conformPassword.trim()) {
        setConformPasswordError("");
        if (currentPassword.trim() == newPassword.trim()) {
          setNewPasswordError(
            "New password cannot be the same as current password."
          );
          isvalid = false;
        } else {
          setNewPasswordError("");
        }
        // isvalid = true
      } else {
        setConformPasswordError("Password mismatch");
        isvalid = false;
      }
    }
    debugger;

    if (isvalid) {
      // let data = {
      //   currentPassword: currentPassword,
      //   newPassword: newPassword,
      // };
      // props.dispatch(changePassword(data));
      setResetDialog(true);
    }
  };

  const yesActionReset = () => {
    let data = {
      currentPassword: currentPassword,
      newPassword: newPassword,
    };
    setResetDialog(false);
    props.dispatch(changePassword(data)).then((res) => {
      props.handleLogout();
    });
  };

  const validatePhoneNumberByDialCode = (countryCode, phoneNumber) => {
    try {
      const fullNumber = `${countryCode}${phoneNumber}`;
      const phone = parsePhoneNumberFromString(fullNumber);
      return phone && phone.isValid();
    } catch (error) {
      console.error("Validation failed:", error.message);
      return false;
    }
  };
  const handleTogglePassword = () => {
    setToggleConformPassword(!toggleConformPassword);
  };
  const handleTogglenewPassword = () => {
    setTogglenewpassword(!togglenewpassword);
  };
  const handleTogglecurrentPassword = () => {
    setToggleCurrentpassword(!toggleCurrentpassword);
  };
  return !isWebMobile ? (
    <div>
      <Backdrop
        className="spinner-backdrop"
        open={props.addUserIsLoader || props.isLoading1}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <div className="mt-3 pe-4">
        <h3 className="profile-ui-header">Profile</h3>
      </div>
      {/* <hr /> */}
      <div className=" mt-3 ps-0 pe-5  row">
        <div className="col-xxl-2 col-xl-3 col-lg-3 col-3 ">
          <div className="d-flex gap-2">
            {basicDetails ? (
              <CommonIcon fileName={"profiledetails"} />
            ) : (
              <CommonIcon fileName={"profiledetailsunslect"} />
            )}
            <h4
              className={`text-start ${
                basicDetails ? "profile-header" : "profile-headerunselect"
              } `}
              onClick={handleBasicDetails}
            >
              Basic Details
            </h4>
          </div>

          {/* {localStorage.getItem('isSSO')=="false"?<h4 className="text-start profile-header" onClick={handlepasswordchange}>Change Password</h4>:''} */}

          {!isSSO ? (
            <div className="d-flex gap-2">
              {tooglepassword ? (
                <CommonIcon fileName={"profilechangepassword"} />
              ) : (
                <CommonIcon fileName={"profilechangepasswordunslect"} />
              )}
              <h4
                className={`text-start ${
                  tooglepassword ? "profile-header" : "profile-headerunselect"
                } `}
                onClick={handlepasswordchange}
              >
                Change Password
              </h4>
            </div>
          ) : (
            ""
          )}
          {/* <div className="d-flex gap-2">
            {opendialog ? (
              <CommonIcon fileName={"profilelogout"} />
            ) : (
              <CommonIcon fileName={"profilelogoutunslect"} />
            )}
            <h4
              className={`text-start ${
                opendialog ? "profile-header" : "profile-headerunselect"
              } `}
              onClick={() => {
                setOpendialog(true);
              }}
            >
              Logout
            </h4>
          </div> */}
        </div>

        <form className="col-xxl-10 col-xl-9 col-lg-9 col-9 pe-3 ">
          <div className="form-row">
            <div
              className="form-group col-12"
              style={{ display: basicDetails ? "block" : "none" }}
            >
              <FormLabel className="formlabel-style w-100">
                Email (User Name)
              </FormLabel>
              <TextField
                disabled
                id="email"
                className={`filter_input br-4 `}
                variant="filled"
                value={email}
                style={{ width: "90%" }}
              />
            </div>

            <div
              className="form-group col-12 mt-2"
              style={{ display: basicDetails ? "block" : "none", width: "90%" }}
            >
              <div className="d-flex justify-content-between  row">
                <div className="col-6">
                  <FormLabel className="formlabel-style w-100">
                    First Name
                  </FormLabel>
                  <TextField
                    id="first_name"
                    className="filter_input br-4"
                    variant="filled"
                    focused
                    style={{ width: "100%" }}
                    value={firstName}
                    inputProps={{ maxLength: 255 }}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div
                  className="col-6"
                  style={{ display: basicDetails ? "block" : "none" }}
                >
                  <FormLabel className="formlabel-style w-100">
                    Last Name
                  </FormLabel>
                  <TextField
                    id="last_name"
                    className="filter_input br-4"
                    variant="filled"
                    focused
                    style={{ width: "100%" }}
                    value={lastName}
                    inputProps={{ maxLength: 255 }}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-12 mt-2"
              style={{
                display: basicDetails ? "block" : "none",
              }}
            >
              <FormLabel className="formlabel-style w-100">
                Phone Number
              </FormLabel>
              <div className="d-flex" style={{ width: "90%" }}>
                <Autocomplete
                  options={countryData}
                  className="filter_input123"
                  error={phoneError}
                  getOptionLabel={(option) => option.countryCode || ""}
                  value={
                    countryData.find((item) => item.countryCode == phoneCode) ||
                    null
                  }
                  onChange={(e, newValue) => {
                    setPhonceCode(
                      newValue?.countryCode ? newValue.countryCode : ""
                    );
                  }}
                  // renderOption={(props, option, { selected }) => (
                  //   <li {...props} key={option.id}>
                  //     {option.countryCode}
                  //   </li>
                  // )}
                  renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                      <Box
                        key={option.id}
                        component="li"
                        sx={{
                          "& > img": { mr: 1.5, flexShrink: 0 },
                        }}
                        {...optionProps}
                      >
                        <img
                          loading="lazy"
                          width="24"
                          height="18"
                          srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                          src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                          alt=""
                        />
                        {option.countryCode}
                      </Box>
                    );
                  }}
                  filterOptions={(options, state) => {
                    const input = state.inputValue
                      .replace("+", "")
                      .trim()
                      .toLowerCase();
                    console.log(input, "filter check");

                    return options.filter((option) => {
                      const code =
                        option.countryCode?.replace("+", "").toLowerCase() ||
                        "";
                      const name = option.countryName?.toLowerCase() || "";

                      // ✅ Match either country code or country name
                      return code.includes(input) || name.includes(input);
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      error={phoneError}
                      // error={this.state.phoneError}
                      className="filter_input123" // or "outlined" if needed
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        // removes underline
                      }}
                    />
                  )}
                  sx={{
                    width: 150,
                    "& .MuiInputBase-root": {
                      borderRight: "none !important",
                      outline: "none",
                      padding: "6px",
                      paddingLeft: "12px",
                      fontSize: "13px",
                    },
                  }}
                />
                <TextField
                  id="phonenumber"
                  className="filter_input br-4"
                  variant="filled"
                  focused
                  error={phoneError}
                  value={phone}
                  fullWidth
                  // onChange={(e) => setPhone(e.target.value)}
                  onChange={(e) => {
                    const filteredValue = e.target.value.replace(/[^0-9]/g, "");
                    setPhone(filteredValue);
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      borderLeft: "none !important",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    },
                  }}
                />
              </div>
              {phoneError && <span className="errorMessage">{phoneError}</span>}
            </div>
            {/* <label className='mt-4' id='changepassword' onClick={handlepasswordchange}>Change Password</label>   */}
            <div
              className="form-group col-12"
              id="pass-div"
              style={{ display: tooglepassword ? "block" : "none" }}
            >
              <div className="row ">
                <div className="col-6">
                  <FormLabel className="formlabel-style w-100">
                    Current Password<span className={`isrequired`}>*</span>
                  </FormLabel>
                  <TextField
                    error={currentpasswordError}
                    id="current_password"
                    className="filter_input br-4"
                    variant="filled"
                    focused
                    type={toggleCurrentpassword ? "password" : "text"}
                    style={{ width: "100%" }}
                    value={currentPassword}
                    inputProps={{ maxLength: 255 }}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span
                            onClick={handleTogglecurrentPassword}
                            style={{ cursor: "pointer" }}
                          >
                            <CommonIcon
                              fileName={
                                toggleCurrentpassword
                                  ? "passwordvisibleoff"
                                  : "passwordvisible"
                              }
                            />
                          </span>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {currentpasswordError && (
                    <span className="error-message" style={{ color: "red" }}>
                      {currentpasswordError}
                    </span>
                  )}
                </div>
                <div className="w-100"></div>

                <div className="col-6">
                  <FormLabel className="formlabel-style w-100">
                    New Password<span className={`isrequired`}>*</span>
                  </FormLabel>
                  <TextField
                    error={newpasswordError}
                    id="new_password"
                    className="filter_input br-4"
                    inputProps={{ maxLength: 255 }}
                    variant="filled"
                    type={togglenewpassword ? "password" : "text"}
                    focused
                    style={{ width: "100%" }}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span
                            onClick={handleTogglenewPassword}
                            style={{ cursor: "pointer" }}
                          >
                            <CommonIcon
                              fileName={
                                togglenewpassword
                                  ? "passwordvisibleoff"
                                  : "passwordvisible"
                              }
                            />
                          </span>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {newpasswordError && (
                    <span className="error-message" style={{ color: "red" }}>
                      {newpasswordError}
                    </span>
                  )}
                </div>
                <div
                  className="col-6"
                  id="pass-div"
                  style={{
                    marginLeft: "-3px",
                    display: tooglepassword ? "block" : "none",
                  }}
                >
                  <FormLabel className="formlabel-style w-100">
                    Confirm New Password<span className={`isrequired`}>*</span>
                  </FormLabel>
                  <TextField
                    error={conformpasswordError}
                    id="confirm_password"
                    className="filter_input br-4"
                    fullWidth
                    inputProps={{ maxLength: 255 }}
                    variant="filled"
                    focused
                    type={toggleConformPassword ? "password" : "text"}
                    value={conformPassword}
                    onChange={(e) => setConformPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span
                            onClick={handleTogglePassword}
                            style={{ cursor: "pointer" }}
                          >
                            <CommonIcon
                              fileName={
                                toggleConformPassword
                                  ? "passwordvisibleoff"
                                  : "passwordvisible"
                              }
                            />
                          </span>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {conformpasswordError && (
                    <span className="error-message" style={{ color: "red" }}>
                      {conformpasswordError}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
          <div className="mt-4">
            {!tooglepassword ? (
              <button
                className={`btn-fun btn-action btn-filter-action`}
                variant="primary"
                type="button"
                onClick={handleUpdate}
              >
                Update
              </button>
            ) : (
              ""
            )}
            {tooglepassword ? (
              <button
                className={`btn-fun btn-action btn-filter-action `}
                variant="primary"
                type="button"
                onClick={handleChangePasswordSubmit}
              >
                Reset
              </button>
            ) : (
              ""
            )}
          </div>
        </form>
      </div>
      {/* ********* logout modal popup *********** */}
      <div
        className={`modal modal-style viewbar-overlay  ${
          opendialog ? "show" : ""
        }`}
        id="Additionform"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: opendialog ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow-lg bg-white rounded">
            <div className="modal-body text-center">
              <CommonIcon fileName={"logouticon"} />
              <br />
              <span>{"Are you sure you want to logout?"}</span>
            </div>
            <div className="modal-footer justify-content-center">
              <Button
                className="btn-no px-4"
                variant="primary"
                onClick={() => noAction()}
              >
                No
              </Button>{" "}
              <Button
                className="btn-action px-4"
                variant="primary"
                onClick={() => yesAction()}
              >
                Yes
              </Button>{" "}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal modal-style viewbar-overlay  ${
          resetDialog ? "show" : ""
        }`}
        id=""
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: resetDialog ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow-lg bg-white rounded">
            <div className="modal-body text-center mt-1">
              <span>
                {"You will be logged out after this change."}
                <br />
              </span>
              <span>{"Please log in again."}</span>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn-no1 px-4"
                variant="primary"
                onClick={() => {
                  setResetDialog(false);
                }}
              >
                Cancel
              </button>{" "}
              <button
                className="btn-action px-4 border-none"
                variant="primary"
                onClick={() => {
                  yesActionReset();
                }}
              >
                Ok
              </button>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <>
      <Backdrop
        className="spinner-backdrop"
        open={props.addUserIsLoader || props.isLoading1}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <div className="row">
        <ToastContainer className="toast-container" />

        <div className="row">
          <div className="col-2">
            <span
              className="mobile-menuusers"
              onClick={() => props.toggleMenu()}
            >
              <CommonIcon fileName={"Menu"} />
            </span>
          </div>
          <div className="col-4 ps-0">
            <span className="headerform-mobile">Profile</span>
          </div>
        </div>
        <div className="ps-4">
          <label className="pathlabel">
            <span className="isblue">Profile &gt;</span>
          </label>
        </div>
        <div>
          <div className="col-12 pt-2 ms-2" style={{ marginRight: "60px" }}>
            <div className="d-flex gap-2">
              {basicDetails ? (
                <CommonIcon fileName={"profiledetails"} />
              ) : (
                <CommonIcon fileName={"profiledetailsunslect"} />
              )}
              <h4
                className={`text-start ${
                  basicDetails ? "profile-header" : "profile-headerunselect"
                } `}
                onClick={handleBasicDetailsmobile}
              >
                Basic Details
              </h4>
            </div>

            {/* {localStorage.getItem('isSSO')=="false"?<h4 className="text-start profile-header" onClick={handlepasswordchange}>Change Password</h4>:''} */}

            {!isSSO ? (
              <div className="d-flex gap-2">
                {tooglepassword ? (
                  <CommonIcon fileName={"profilechangepassword"} />
                ) : (
                  <CommonIcon fileName={"profilechangepasswordunslect"} />
                )}
                <h4
                  className={`text-start ${
                    tooglepassword ? "profile-header" : "profile-headerunselect"
                  } `}
                  onClick={handlepasswordchangemobile}
                >
                  Change Password
                </h4>
              </div>
            ) : (
              ""
            )}
            {/* <div className="d-flex gap-2">
              {opendialog ? (
                <CommonIcon fileName={"profilelogout"} />
              ) : (
                <CommonIcon fileName={"profilelogoutunslect"} />
              )}
              <h4
                className={`text-start ${
                  opendialog ? "profile-header" : "profile-headerunselect"
                } `}
                onClick={() => {
                  setOpendialog(true);
                }}
              >
                Logout
              </h4>
            </div> */}
          </div>
        </div>
      </div>

      {/* BASIC DETAILS */}
      <div
        className="offcanvas offcanvas-end "
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="AddForm"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div className={`offcanvas-header`}>
          <span className="headername1">Details</span>
          <button
            data-bs-dismiss="offcanvas"
            className="offcavasclose "
            onClick={() => closeForm()}
          >
            <CommonIcon fileName={"Close"} />
          </button>
        </div>
        <div className="ps-4">
          <label className="pathlabel">
            Profile &gt;<span className="isblue">Details</span>
          </label>
        </div>

        <div
          className="offcanvas-body ps-4  pt-0"
          style={{ overflow: "hidden" }}
        >
          <form className="col-12 pe-3 ">
            <div className="form-row">
              <div
                className="form-group col-12"
                style={{ display: basicDetails ? "block" : "none" }}
              >
                <FormLabel className="formlabel-style w-100">
                  Email (User Name)
                </FormLabel>
                <TextField
                  disabled
                  id="email"
                  className={`filter_input br-4 `}
                  variant="filled"
                  value={email}
                  style={{ width: "100%" }}
                />
              </div>

              <div
                className="form-group col-12 mt-1"
                style={{ display: basicDetails ? "block" : "none" }}
              >
                <div className="col-12">
                  <FormLabel className="formlabel-style w-100">
                    First Name
                  </FormLabel>
                  <TextField
                    id="first_name"
                    inputProps={{ maxLength: 255 }}
                    className="filter_input br-4"
                    variant="filled"
                    focused
                    style={{ width: "100%" }}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div
                  className="col-12 mt-1"
                  style={{ display: basicDetails ? "block" : "none" }}
                >
                  <FormLabel className="formlabel-style w-100">
                    Last Name
                  </FormLabel>
                  <TextField
                    id="last_name"
                    className="filter_input br-4"
                    inputProps={{ maxLength: 255 }}
                    variant="filled"
                    focused
                    style={{ width: "100%" }}
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
              <div
                className="col-12 mt-1"
                style={{ display: basicDetails ? "block" : "none" }}
              >
                <FormLabel className="formlabel-style w-100">
                  Phone Number
                </FormLabel>
                <div className="d-flex w-100">
                  <Autocomplete
                    options={countryData}
                    error={phoneError}
                    getOptionLabel={(option) => option.countryCode || ""}
                    value={
                      countryData.find(
                        (item) => item.countryCode == phoneCode
                      ) || null
                    }
                    onChange={(e, newValue) => {
                      setPhonceCode(
                        newValue?.countryCode ? newValue.countryCode : ""
                      );
                    }}
                    // renderOption={(props, option, { selected }) => (
                    //   <li {...props} key={option.id}>
                    //     {option.countryCode}
                    //   </li>
                    // )}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Box
                          key={option.id}
                          component="li"
                          sx={{
                            "& > img": { mr: 1.5, flexShrink: 0 },
                          }}
                          {...optionProps}
                        >
                          <img
                            loading="lazy"
                            width="24"
                            height="18"
                            srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                            src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                            alt=""
                          />
                          {option.countryCode}
                        </Box>
                      );
                    }}
                    filterOptions={(options, state) => {
                      const input = state.inputValue
                        .replace("+", "")
                        .trim()
                        .toLowerCase();
                      console.log(input, "filter check");

                      return options.filter((option) => {
                        const code =
                          option.countryCode?.replace("+", "").toLowerCase() ||
                          "";
                        const name = option.countryName?.toLowerCase() || "";

                        // ✅ Match either country code or country name
                        return code.includes(input) || name.includes(input);
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="filled"
                        error={phoneError}
                        // error={this.state.phoneError}
                        className="filter_input123" // or "outlined" if needed
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                          // removes underline
                        }}
                      />
                    )}
                    sx={{
                      width: 150,
                      "& .MuiInputBase-root": {
                        borderRight: "none !important",
                        outline: "none",
                        padding: "6px",
                        paddingLeft: "12px",
                        fontSize: "13px",
                      },
                    }}
                  />
                  <TextField
                    id="phonenumber"
                    className="filter_input br-4"
                    variant="filled"
                    focused
                    value={phone}
                    error={phoneError}
                    style={{ width: "100%" }}
                    // onChange={(e) => setPhone(e.target.value)}
                    onChange={(e) => {
                      const filteredValue = e.target.value.replace(
                        /[^0-9]/g,
                        ""
                      );
                      setPhone(filteredValue);
                    }}
                    sx={{
                      "& .MuiFilledInput-root": {
                        borderLeft: "none !important",
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                      },
                    }}
                  />
                </div>
                {phoneError && (
                  <span className="errorMessage">{phoneError}</span>
                )}
              </div>
            </div>
            <ToastContainer className="toast-container" />
            <div className="mt-4">
              {!tooglepassword ? (
                <button
                  className={`btn-fun btn-action btn-filter-action`}
                  variant="primary"
                  type="button"
                  onClick={handleUpdate}
                >
                  Update
                </button>
              ) : (
                ""
              )}
            </div>
          </form>
        </div>
      </div>

      {/* RESET PASSWORD */}
      <div
        className="offcanvas offcanvas-end "
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="resetpassword"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div className={`offcanvas-header`}>
          <span className="headername1">Change password</span>
          <button
            data-bs-dismiss="offcanvas"
            className="offcavasclose "
            onClick={() => closePasswordForm()}
          >
            <CommonIcon fileName={"Close"} />
          </button>
        </div>
        <div className="ps-4">
          <label className="pathlabel">
            Profile &gt;<span className="isblue">Change password</span>
          </label>
        </div>
        <div
          className="offcanvas-body ps-4  pt-0"
          style={{ overflow: "hidden" }}
        >
          <form className="col-12 pe-3 ">
            <div className="form-row">
              {/* <label className='mt-4' id='changepassword' onClick={handlepasswordchange}>Change Password</label>   */}
              <div
                className="form-group col-12 mt-2"
                id="pass-div"
                style={{ display: tooglepassword ? "block" : "none" }}
              >
                {/* <div className="d-flex justify-content-between align-items-start gap-3 " style={{ width: "89%", marginLeft: '-3px' }}> */}
                <div className="col-12">
                  <FormLabel className="formlabel-style w-100">
                    Current Password<span className={`isrequired`}>*</span>
                  </FormLabel>
                  <TextField
                    error={currentpasswordError}
                    id="current_password"
                    className="filter_input br-4"
                    variant="filled"
                    focused
                    type={toggleCurrentpassword ? "password" : "text"}
                    style={{ width: "100%" }}
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span
                            onClick={handleTogglecurrentPassword}
                            style={{ cursor: "pointer" }}
                          >
                            <CommonIcon
                              fileName={
                                toggleCurrentpassword
                                  ? "passwordvisibleoff"
                                  : "passwordvisible"
                              }
                            />
                          </span>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {currentpasswordError && (
                    <span className="error-message" style={{ color: "red" }}>
                      {currentpasswordError}
                    </span>
                  )}
                </div>

                <div className="col-12">
                  <FormLabel className="formlabel-style w-100">
                    New Password<span className={`isrequired`}>*</span>
                  </FormLabel>
                  <TextField
                    error={newpasswordError}
                    id="new_password"
                    className="filter_input br-4"
                    variant="filled"
                    type={togglenewpassword ? "password" : "text"}
                    focused
                    style={{ width: "100%" }}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span
                            onClick={handleTogglenewPassword}
                            style={{ cursor: "pointer" }}
                          >
                            <CommonIcon
                              fileName={
                                togglenewpassword
                                  ? "passwordvisibleoff"
                                  : "passwordvisible"
                              }
                            />
                          </span>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {newpasswordError && (
                    <span className="error-message" style={{ color: "red" }}>
                      {newpasswordError}
                    </span>
                  )}
                </div>
              </div>

              <div
                className="col-12"
                id="pass-div"
                style={{
                  marginLeft: "-3px",
                  display: tooglepassword ? "block" : "none",
                }}
              >
                <FormLabel className="formlabel-style w-100">
                  Confirm New Password<span className={`isrequired`}>*</span>
                </FormLabel>
                <TextField
                  error={conformpasswordError}
                  id="confirm_password"
                  className="filter_input br-4"
                  variant="filled"
                  focused
                  type={toggleConformPassword ? "password" : "text"}
                  value={conformPassword}
                  style={{ width: "100%" }}
                  onChange={(e) => setConformPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <span
                          onClick={handleTogglePassword}
                          style={{ cursor: "pointer" }}
                        >
                          <CommonIcon
                            fileName={
                              toggleConformPassword
                                ? "passwordvisibleoff"
                                : "passwordvisible"
                            }
                          />
                        </span>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              {conformpasswordError && (
                <span className="error-message" style={{ color: "red" }}>
                  {conformpasswordError}
                </span>
              )}
            </div>

            <div className="mt-4">
              {tooglepassword ? (
                <button
                  className={`btn-fun btn-action btn-filter-action `}
                  variant="primary"
                  type="button"
                  onClick={handleChangePasswordSubmit}
                >
                  Reset
                </button>
              ) : (
                ""
              )}
            </div>
          </form>
        </div>
      </div>

      {/* LOGOUT POPUP MODAL */}

      <div
        className={`modal modal-style viewbar-overlay  ${
          opendialog ? "show" : ""
        }`}
        id="Additionform"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: opendialog ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow-lg bg-white rounded">
            <div className="modal-body text-center">
              <CommonIcon fileName={"logouticon"} />
              <br />
              <span>{"Are you sure you want to logout?"}</span>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn-no px-4"
                variant="primary"
                onClick={() => noAction()}
              >
                No
              </button>{" "}
              <button
                className="btn-action px-4 border-none"
                variant="primary"
                onClick={() => yesAction()}
              >
                Yes
              </button>{" "}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal modal-style viewbar-overlay  ${
          resetDialog ? "show" : ""
        }`}
        id=""
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: resetDialog ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow-lg bg-white rounded">
            <div className="modal-body text-center mt-1">
              <span>
                {"You will be logged out after this change."}
                <br />
              </span>
              <span>{"Please log in again."}</span>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn-no1 px-4"
                variant="primary"
                onClick={() => {
                  setResetDialog(false);
                }}
              >
                Cancel
              </button>{" "}
              <button
                className="btn-action px-4 border-none"
                variant="primary"
                onClick={() => {
                  yesActionReset();
                }}
              >
                Ok
              </button>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    dispatch,
  };
};
const mapStateToProps = (state) => {
  return {
    ShowSideBar: state.SideBarReducer.ShowSideBar,
    menuToggle: state.SideBarReducer.menuToggle,
    isLogin: state.loginReducer.isLogin,
    getParticularUser: state.userReducer.getParticularUser,
    updateUser: state.userReducer.updateUser,
    changePassword: state.userReducer.changePassword,
    addUserIsLoader: state.commonReducer.addUserIsLoader,
    isLoading1: state.commonReducer.isLoading1,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUI);
